module.exports = __webpack_public_path__ + "img/spartan-bio.a888d4c3.jpg";